// extracted by mini-css-extract-plugin
export var formContainer = "_ls-0";
export var message = "_ls-1";